const NavigateIcon = () => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      id='Vector (Stroke)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.11675 0.302596C7.18952 0.0842865 7.42549 -0.0336968 7.6438 0.0390731L11.366 1.27979C12.4857 1.65305 13.3644 2.53173 13.7377 3.6515L14.9784 7.37366C15.0512 7.59197 14.9332 7.82794 14.7149 7.90071C14.4966 7.97348 14.2606 7.8555 14.1878 7.63719L12.9471 3.91503C12.8472 3.61525 12.7007 3.33769 12.516 3.09072L1.68737 13.9193C1.52465 14.0821 1.26083 14.0821 1.09811 13.9193C0.935395 13.7566 0.935395 13.4928 1.09811 13.3301L11.9267 2.50147C11.6798 2.31678 11.4022 2.17029 11.1024 2.07036L7.38028 0.829643C7.16197 0.756873 7.04398 0.520906 7.11675 0.302596Z'
      fill='black'
    />
  </svg>
)

export default NavigateIcon
